/**
 * Adds the JW Player playlist tags of a media to `customParams` (mutated):
 * `tag-1` is the content type, then one tag per genre, then `<type>-<genre>`.
 * e.g. ("movie", [{ name: "Drama" }]) → { "tag-1": "movie", "tag-2": "Drama", "tag-3": "movie-Drama" }
 */
export function addGenreTags(customParams, type, genres) {
  const names = (genres || []).map((genre) => genre.name);
  customParams["tag-1"] = type;
  names.forEach((name, index) => {
    customParams[`tag-${index + 2}`] = name;
  });
  names.forEach((name, index) => {
    customParams[`tag-${names.length + index + 2}`] = `${type}-${name}`;
  });
  return customParams;
}
